import React from "react";
import { styled, Theme, CSSObject, useTheme } from "@mui/material/styles";
const NoContant = () => {
  const theme = useTheme();
  const SvgRapper = styled("svg")`
    & path {
      fill: #919EAB !important;
    }
  `;
  return (
    <>
      <SvgRapper
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 181 135.5"
      >
        <g id="Group_6248" transform="translate(-714 -468)">
          <g>
            <path d="M722.8,599.5h-1.3l-5-7.7v7.7h-1.3v-10h1.3l5,7.7v-7.7h1.3V599.5z" />
            <path
              d="M724.6,595.7c0-0.7,0.1-1.4,0.4-2s0.7-1,1.2-1.3s1.1-0.5,1.7-0.5c1,0,1.8,0.3,2.4,1s0.9,1.6,0.9,2.8v0.1
			c0,0.7-0.1,1.4-0.4,1.9c-0.3,0.6-0.7,1-1.2,1.3s-1.1,0.5-1.8,0.5c-1,0-1.8-0.3-2.4-1S724.6,597,724.6,595.7L724.6,595.7z
			 M725.9,595.9c0,0.8,0.2,1.5,0.6,2s0.9,0.7,1.5,0.7c0.6,0,1.2-0.3,1.5-0.8c0.4-0.5,0.6-1.2,0.6-2.1c0-0.8-0.2-1.5-0.6-2
			c-0.4-0.5-0.9-0.8-1.5-0.8c-0.6,0-1.1,0.2-1.5,0.7S725.9,595,725.9,595.9z"
            />
            <path
              d="M734.6,590.3v1.8h1.4v1h-1.4v4.6c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2c0.1,0,0.3,0,0.6-0.1v1
			c-0.3,0.1-0.7,0.1-1,0.1c-0.6,0-1-0.2-1.3-0.5s-0.4-0.8-0.4-1.5v-4.6H732v-1h1.3v-1.8H734.6z"
            />
            <path
              d="M738.8,593c0.6-0.7,1.3-1,2.2-1c1.6,0,2.4,0.9,2.4,2.6v4.9H742v-4.9c0-0.5-0.1-0.9-0.4-1.2s-0.6-0.4-1.1-0.4
			c-0.4,0-0.8,0.1-1.1,0.3s-0.6,0.5-0.7,0.9v5.3h-1.3V589h1.3V593z"
            />
            <path
              d="M745.2,590.1c0-0.2,0.1-0.4,0.2-0.5s0.3-0.2,0.6-0.2s0.4,0.1,0.6,0.2s0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5
			s-0.3,0.2-0.6,0.2s-0.4-0.1-0.6-0.2S745.2,590.3,745.2,590.1z M746.6,599.5h-1.3v-7.4h1.3V599.5z"
            />
            <path
              d="M749.8,592.1l0,0.9c0.6-0.7,1.3-1.1,2.2-1.1c1.6,0,2.4,0.9,2.4,2.6v4.9h-1.3v-4.9c0-0.5-0.1-0.9-0.4-1.2
			s-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1.1,0.3s-0.6,0.5-0.7,0.9v5.3h-1.3v-7.4H749.8z"
            />
            <path
              d="M756,595.7c0-1.2,0.3-2.1,0.8-2.8c0.5-0.7,1.2-1,2.1-1c0.9,0,1.6,0.3,2.1,1l0.1-0.8h1.2v7.2
			c0,1-0.3,1.7-0.9,2.3s-1.3,0.8-2.3,0.8c-0.5,0-1.1-0.1-1.6-0.3s-0.9-0.5-1.2-0.9l0.7-0.8c0.5,0.7,1.2,1,2,1c0.6,0,1.1-0.2,1.4-0.5
			s0.5-0.8,0.5-1.5v-0.6c-0.5,0.6-1.2,0.9-2.1,0.9c-0.9,0-1.6-0.3-2.1-1S756,596.9,756,595.7z M757.3,595.9c0,0.8,0.2,1.5,0.5,2
			c0.3,0.5,0.8,0.7,1.4,0.7c0.8,0,1.4-0.4,1.8-1.1v-3.4c-0.4-0.7-1-1.1-1.7-1.1c-0.6,0-1.1,0.2-1.4,0.7S757.3,594.9,757.3,595.9z"
            />
            <path
              d="M767.7,590.1c0-0.2,0.1-0.4,0.2-0.5s0.3-0.2,0.6-0.2s0.4,0.1,0.6,0.2s0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5
			s-0.3,0.2-0.6,0.2s-0.4-0.1-0.6-0.2S767.7,590.3,767.7,590.1z M769,599.5h-1.3v-7.4h1.3V599.5z"
            />
            <path
              d="M772.2,592.1l0,0.9c0.6-0.7,1.3-1.1,2.2-1.1c1.6,0,2.4,0.9,2.4,2.6v4.9h-1.3v-4.9c0-0.5-0.1-0.9-0.4-1.2
			s-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1.1,0.3s-0.6,0.5-0.7,0.9v5.3H771v-7.4H772.2z"
            />
            <path d="M783.6,599.5h-1.3V589h1.3V599.5z" />
            <path
              d="M785.6,590.1c0-0.2,0.1-0.4,0.2-0.5s0.3-0.2,0.6-0.2s0.4,0.1,0.6,0.2s0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5
			s-0.3,0.2-0.6,0.2s-0.4-0.1-0.6-0.2S785.6,590.3,785.6,590.1z M787,599.5h-1.3v-7.4h1.3V599.5z"
            />
            <path
              d="M793.3,597.5c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.7-0.4-1.3-0.5s-1.1-0.3-1.5-0.5s-0.7-0.4-0.8-0.7
			s-0.3-0.6-0.3-0.9c0-0.6,0.3-1.1,0.8-1.5s1.2-0.6,2-0.6c0.8,0,1.5,0.2,2,0.6s0.8,1,0.8,1.7h-1.3c0-0.3-0.1-0.6-0.4-0.9
			s-0.7-0.4-1.1-0.4c-0.5,0-0.8,0.1-1.1,0.3s-0.4,0.5-0.4,0.8c0,0.3,0.1,0.5,0.4,0.7s0.7,0.3,1.3,0.4s1.1,0.3,1.5,0.5
			s0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.6,0.3,1c0,0.7-0.3,1.2-0.8,1.6c-0.5,0.4-1.2,0.6-2.1,0.6c-0.6,0-1.1-0.1-1.6-0.3s-0.8-0.5-1.1-0.9
			c-0.3-0.4-0.4-0.8-0.4-1.2h1.3c0,0.4,0.2,0.8,0.5,1c0.3,0.2,0.7,0.4,1.3,0.4c0.5,0,0.9-0.1,1.2-0.3
			C793.2,598.1,793.3,597.9,793.3,597.5z"
            />
            <path
              d="M798,590.3v1.8h1.4v1H798v4.6c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2c0.1,0,0.3,0,0.6-0.1v1
			c-0.3,0.1-0.7,0.1-1,0.1c-0.6,0-1-0.2-1.3-0.5s-0.4-0.8-0.4-1.5v-4.6h-1.3v-1h1.3v-1.8H798z"
            />
            <path
              d="M808.9,599.5c-0.1-0.1-0.1-0.4-0.2-0.8c-0.6,0.6-1.3,0.9-2.1,0.9c-0.7,0-1.3-0.2-1.8-0.6
			c-0.5-0.4-0.7-0.9-0.7-1.6c0-0.8,0.3-1.4,0.9-1.8c0.6-0.4,1.4-0.6,2.5-0.6h1.2v-0.6c0-0.4-0.1-0.8-0.4-1.1
			c-0.3-0.3-0.7-0.4-1.2-0.4c-0.5,0-0.8,0.1-1.1,0.3s-0.5,0.5-0.5,0.8h-1.3c0-0.4,0.1-0.7,0.4-1.1c0.3-0.3,0.6-0.6,1.1-0.8
			c0.4-0.2,0.9-0.3,1.5-0.3c0.9,0,1.5,0.2,2,0.6c0.5,0.4,0.7,1,0.8,1.8v3.4c0,0.7,0.1,1.2,0.3,1.6v0.1H808.9z M806.8,598.5
			c0.4,0,0.8-0.1,1.1-0.3s0.6-0.5,0.8-0.8v-1.5h-1c-1.5,0-2.3,0.5-2.3,1.4c0,0.4,0.1,0.7,0.4,0.9S806.3,598.5,806.8,598.5z"
            />
            <path
              d="M813.6,590.3v1.8h1.4v1h-1.4v4.6c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2c0.1,0,0.3,0,0.6-0.1v1
			c-0.3,0.1-0.7,0.1-1,0.1c-0.6,0-1-0.2-1.3-0.5s-0.4-0.8-0.4-1.5v-4.6H811v-1h1.3v-1.8H813.6z"
            />
            <path
              d="M821.7,590.3v1.8h1.4v1h-1.4v4.6c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2c0.1,0,0.3,0,0.6-0.1v1
			c-0.3,0.1-0.7,0.1-1,0.1c-0.6,0-1-0.2-1.3-0.5s-0.4-0.8-0.4-1.5v-4.6H819v-1h1.3v-1.8H821.7z"
            />
            <path
              d="M825.8,593c0.6-0.7,1.3-1,2.2-1c1.6,0,2.4,0.9,2.4,2.6v4.9h-1.3v-4.9c0-0.5-0.1-0.9-0.4-1.2
			c-0.2-0.3-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1.1,0.3s-0.6,0.5-0.7,0.9v5.3h-1.3V589h1.3V593z"
            />
            <path
              d="M835.3,599.6c-1,0-1.8-0.3-2.4-1c-0.6-0.7-0.9-1.5-0.9-2.6v-0.2c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.7-1,1.2-1.4
			c0.5-0.3,1-0.5,1.6-0.5c1,0,1.7,0.3,2.2,1s0.8,1.5,0.8,2.7v0.5h-5c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,0.9,0.7,1.6,0.7
			c0.4,0,0.8-0.1,1.1-0.3s0.6-0.4,0.8-0.7l0.8,0.6C837.5,599.2,836.5,599.6,835.3,599.6z M835.1,593c-0.5,0-0.9,0.2-1.3,0.6
			c-0.3,0.4-0.6,0.9-0.6,1.6h3.7V595c0-0.6-0.2-1.1-0.5-1.5C836.1,593.2,835.7,593,835.1,593z"
            />
            <path
              d="M844.3,592.1l0,0.8c0.5-0.6,1.3-1,2.2-1c1,0,1.7,0.4,2.1,1.2c0.2-0.4,0.6-0.6,1-0.9c0.4-0.2,0.9-0.3,1.4-0.3
			c1.6,0,2.4,0.9,2.5,2.6v5h-1.3v-4.9c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.6-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.4
			c-0.3,0.3-0.5,0.7-0.5,1.1v4.9h-1.3v-4.8c0-1.1-0.5-1.6-1.6-1.6c-0.8,0-1.4,0.4-1.7,1.1v5.4h-1.3v-7.4H844.3z"
            />
            <path
              d="M855,595.7c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.7-1,1.2-1.3c0.5-0.3,1.1-0.5,1.7-0.5c1,0,1.8,0.3,2.4,1
			c0.6,0.7,0.9,1.6,0.9,2.8v0.1c0,0.7-0.1,1.4-0.4,1.9c-0.3,0.6-0.7,1-1.2,1.3c-0.5,0.3-1.1,0.5-1.8,0.5c-1,0-1.8-0.3-2.4-1
			C855.4,597.9,855,597,855,595.7L855,595.7z M856.3,595.9c0,0.8,0.2,1.5,0.6,2c0.4,0.5,0.9,0.7,1.5,0.7c0.6,0,1.2-0.3,1.5-0.8
			c0.4-0.5,0.6-1.2,0.6-2.1c0-0.8-0.2-1.5-0.6-2c-0.4-0.5-0.9-0.8-1.5-0.8c-0.6,0-1.1,0.2-1.5,0.7S856.3,595,856.3,595.9z"
            />
            <path
              d="M864.6,592.1l0,0.8c0.5-0.6,1.3-1,2.2-1c1,0,1.7,0.4,2.1,1.2c0.2-0.4,0.6-0.6,1-0.9c0.4-0.2,0.9-0.3,1.4-0.3
			c1.6,0,2.4,0.9,2.5,2.6v5h-1.3v-4.9c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.6-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.4
			c-0.3,0.3-0.5,0.7-0.5,1.1v4.9h-1.3v-4.8c0-1.1-0.5-1.6-1.6-1.6c-0.8,0-1.4,0.4-1.7,1.1v5.4h-1.3v-7.4H864.6z"
            />
            <path
              d="M878.7,599.6c-1,0-1.8-0.3-2.4-1c-0.6-0.7-0.9-1.5-0.9-2.6v-0.2c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.7-1,1.2-1.4
			c0.5-0.3,1-0.5,1.6-0.5c1,0,1.7,0.3,2.2,1s0.8,1.5,0.8,2.7v0.5h-5c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,0.9,0.7,1.6,0.7
			c0.4,0,0.8-0.1,1.1-0.3s0.6-0.4,0.8-0.7l0.8,0.6C880.9,599.2,879.9,599.6,878.7,599.6z M878.5,593c-0.5,0-0.9,0.2-1.3,0.6
			c-0.3,0.4-0.6,0.9-0.6,1.6h3.7V595c0-0.6-0.2-1.1-0.5-1.5C879.5,593.2,879.1,593,878.5,593z"
            />
            <path
              d="M884.2,592.1l0,0.9c0.6-0.7,1.3-1.1,2.2-1.1c1.6,0,2.4,0.9,2.4,2.6v4.9h-1.3v-4.9c0-0.5-0.1-0.9-0.4-1.2
			c-0.2-0.3-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1.1,0.3s-0.6,0.5-0.7,0.9v5.3h-1.3v-7.4H884.2z"
            />
            <path
              d="M892.5,590.3v1.8h1.4v1h-1.4v4.6c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2c0.1,0,0.3,0,0.6-0.1v1
			c-0.3,0.1-0.7,0.1-1,0.1c-0.6,0-1-0.2-1.3-0.5s-0.4-0.8-0.4-1.5v-4.6h-1.3v-1h1.3v-1.8H892.5z"
            />
          </g>
          <g id="noun-clipboard-411413" transform="translate(575.799 417.09)">
            <path
              id="Path_1994"
              d="M258.4,64.9h-9.3c0-2.6-2.1-4.7-4.7-4.7h-4.7c-1.1-5.5-6-9.4-11.6-9.3
			c-6.1,0-10.2,4.2-11.6,9.3h-4.7c-2.6,0-4.7,2.1-4.7,4.7h-9.3c-2.6,0-4.7,2.1-4.7,4.7v79.2c0,2.6,2.1,4.7,4.7,4.7h60.5
			c2.6,0,4.7-2.1,4.7-4.7V69.5c0.1-2.4-1.7-4.5-4.1-4.7C258.7,64.9,258.6,64.9,258.4,64.9L258.4,64.9z M211.8,64.9h9.8
			c-0.4-0.7-0.5-1.5-0.5-2.3c0-3.9,3.1-7,7-7s7,3.1,7,7c0.1,0.8-0.1,1.6-0.5,2.3h9.8v9.3h-32.6L211.8,64.9z M258.4,148.7h-60.5V69.5
			h9.3v4.7c0,2.6,2.1,4.7,4.7,4.7h32.6c2.6,0,4.7-2.1,4.7-4.7v-4.7h9.3V148.7z"
            />
            <path
              id="Path_1995"
              d="M228.1,113.8c5.6,0,10.2,4.6,10.2,10.2h4.2c0-7.7-6.3-13.9-14-14c-7.6,0.2-13.8,6.3-14,14h4.2
			C217.9,118.4,222.5,113.8,228.1,113.8z"
            />
            <path
              id="Path_1996"
              d="M223.5,97.9c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3
			C222.4,95.6,223.5,96.6,223.5,97.9C223.5,97.9,223.5,97.9,223.5,97.9"
            />
            <path
              id="Path_1997"
              d="M237.9,97.9c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3
			C236.9,95.6,237.9,96.6,237.9,97.9C237.9,97.9,237.9,97.9,237.9,97.9"
            />
          </g>
        </g>
      </SvgRapper>
    </>
  );
};

export default NoContant;
